import type { LangDto } from '@skillarea/lib-shared';

import { getClientBrowserLocale } from '~/lib/locale';
import { cookiesStore } from '~/stores/cookiesStore';
import { onboardStore } from '~/stores/onboardStore';
import { userStore } from '~/stores/userStore';

function buildLangDto(current: string): LangDto {
  return {
    current,
    locale: getClientBrowserLocale() ?? current,
  };
}

export async function persistLocaleCookie(
  current: string,
  options?: { syncUserProfile?: boolean },
): Promise<void> {
  const lang = buildLangDto(current);

  await cookiesStore.saveLang({ body: lang });

  if (!options?.syncUserProfile || !onboardStore.getState().isLoggedIn) {
    return;
  }

  await userStore.getState().saveUserLang(lang);
}
